export default "__VITE_ASSET__HsuNT4Cn__"